/** @const {Object.<string, string>} - Map of system level privileges */
export const PRIVILEGES = {
  MANAGE_ENTIRE_QUEUE: 'manageEntireQueue',
  MANAGE_PROJECT_ACCESS: 'manageProjectAccess',
  MANAGE_PROJECT_TRANSACTIONS: 'manageProjectTransactions',
  MANAGE_UPGRADE_COST_ESTIMATE: 'manageUpgradeCostEstimate',
  VIEW_ENTIRE_QUEUE: 'viewEntireQueue',
  VIEW_VERSION_HISTORY: 'viewVersionHistory',
}

export const ROLES = {
  GRID_UNITY_ADMIN: 'GridUnityAdmin',
}
